import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Processes } from "@src/components/MainApp/Alerts/Processes";
import { SettingsSideNav } from "@src/components/Navigation/SettingsSideNav/SettingsSideNav";
import { useExitSettings } from "@src/hooks/useExitSettings";
import { IgPageContent } from "@src/utils/IgPageContent";

import { AppLayoutShell } from "./layout/AppLayoutShell";

export const SettingsPageProvider = () => {
  const handleExitSettings = useExitSettings();
  const theme = useTheme();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        handleExitSettings();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleExitSettings]);

  return (
    <AppLayoutShell sideNav={<SettingsSideNav />} maxWidth="none">
      <IgPageContent
        paddingX={0}
        childrenSx={{
          backgroundColor: theme.igBackgroundColors.baseLightHigh,
        }}
      >
        <Grid sx={{ paddingX: 10 }}>
          <Processes />
        </Grid>
        <Outlet />
      </IgPageContent>
    </AppLayoutShell>
  );
};
